// src/i18n/index.js
import { createI18n } from "vue-i18n";

import sk from "./locales/sk.json";
import cs from "./locales/cs.json";
import pl from "./locales/pl.json";

function detectLocale() {
  const fromQuery = new URLSearchParams(window.location.search).get("lang");
  const saved = localStorage.getItem("ha.locale");
  const browser = (navigator.language || "sk").slice(0, 2).toLowerCase();
  const candidate = fromQuery || saved || browser;
  return ["sk", "cs", "pl"].includes(candidate) ? candidate : "sk";
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true, // umožní {{ $t('...') }} v šablónach
  locale: detectLocale(),
  fallbackLocale: "sk",
  messages: { sk, cs, pl },
});

export async function setLocale(locale) {
  if (!["sk", "cs", "pl"].includes(locale)) return;
  i18n.global.locale.value = locale;
  localStorage.setItem("ha.locale", locale);
  document.documentElement.setAttribute("lang", locale);
  document.documentElement.setAttribute("data-locale", locale);
}

export default i18n;
